<template>
  <div class="client-avatar-and-name flex flex-gap-1 align-items-center">
    <ClientAvatar
      :accent-color="accentColor"
      :name="name"
      :logo="logo"
      :size="size"
    />

    <slot name="name" :value="name">
      {{ name }}
    </slot>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { toRefs } from 'vue';

import { DomainBranding } from '@rygen/rygen-ui/model';

import ClientAvatar from '@/components/client/ClientAvatar.vue';

const props = defineProps({
  accentColor: {
    type: String,
    default: () => DomainBranding.DEFAULT_ACCENT_COLOR,
  },
  name: {
    type: String,
    default: () => undefined,
  },
  logo: {
    type: String,
    default: () => undefined,
  },
  size: {
    type: String as PropType<'normal' | 'large' | 'xlarge'>,
    default: 'normal',
  },
});
const { accentColor, name, logo, size } = toRefs(props);

defineSlots<{
  name: (props: { value?: string }) => any;
}>();
</script>
